module.exports = __webpack_public_path__ + "img/Wp_2067.172069e9.png";